import { generatePath } from 'react-router-dom';
import { ApiCacheTags, baseApiService } from '@qapline/api';
import { DEFAULT_CONFIG } from '@qapline/config';

import { customerUserSchema, TCustomerUser } from '../schemas';
import { TGetCustomerUsersRequestBody } from '../types';

const { list: listEndpoint, get: getEndpoint } = DEFAULT_CONFIG.api.endpoints.customerUser;
const { list: listTag, item: itemTag } = ApiCacheTags.customerUser;

export const customerUserApi = baseApiService.injectEndpoints({
    endpoints: (builder) => ({
        getCustomerUsers: builder.query<TCustomerUser[], TGetCustomerUsersRequestBody>({
            query: ({ customerId }) => ({
                url: generatePath(listEndpoint, { customerId: customerId.toString() }),
                method: 'GET',
            }),
            providesTags: (_res, error, { customerId }) => (error ? [] : [{ type: listTag, id: customerId }]),
            transformResponse: (data) => customerUserSchema.array().parse(data),
        }),
        getCustomerUser: builder.query<TCustomerUser, number>({
            query: (customerUserId) => ({
                url: generatePath(getEndpoint, { customerUserId: customerUserId.toString() }),
                method: 'GET',
            }),
            providesTags: (_res, error, customerUserId) => (error ? [] : [{ type: itemTag, id: customerUserId }]),
            transformResponse: (data) => customerUserSchema.parse(data),
        }),
    }),
});

export const {
    useGetCustomerUsersQuery,
    useLazyGetCustomerUsersQuery,
    useGetCustomerUserQuery,
    useLazyGetCustomerUserQuery,
} = customerUserApi;
